import { css } from '@emotion/react'
import { colors, Tooltip } from 'plume-ui'
import { twitterShareUrl, facebookShareUrl, articleUrl } from '@/lib/url'
import React, { AnchorHTMLAttributes } from 'react'
import { TwitterIcon, FacebookIcon } from '../../atoms/SocialIcon'
import { Article } from '../../../types'

type Props = {
  article: Article
  title: string
  className?: string
}

export const BottomShareMenu: React.FC<Props> = (props) => {
  const baseUrl = articleUrl(props.article)
  const twitterUrl = twitterShareUrl(baseUrl, props.title)
  const facebookUrl = facebookShareUrl(baseUrl)

  return (
    <div
      css={css`
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        grid-gap: 36px;
      `}
      className={props.className}
    >
      <IconLink
        href={twitterUrl}
        target="_blank"
        color={colors.twitter}
        label="Xでシェア"
      >
        <TwitterIcon size={20} />
      </IconLink>
      <IconLink
        href={facebookUrl}
        target="_blank"
        color={colors.facebook}
        label="Facebookでシェア"
      >
        <FacebookIcon size={20} />
      </IconLink>
    </div>
  )
}

const IconLink: React.FC<
  {
    color: string
    label: string
  } & AnchorHTMLAttributes<HTMLAnchorElement>
> = ({ color, label, ...props }) => {
  return (
    <Tooltip label={label}>
      <a
        css={css`
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: ${colors.gray80};
          border-radius: 100%;
          i {
            color: ${colors.white00};
          }
          :hover {
            background-color: ${color};
          }
        `}
        {...props}
      />
    </Tooltip>
  )
}
